import { render, staticRenderFns } from "./delivery-list.vue?vue&type=template&id=36f569d9&scoped=true&"
import script from "./delivery-list.vue?vue&type=script&lang=js&"
export * from "./delivery-list.vue?vue&type=script&lang=js&"
import style0 from "./delivery-list.vue?vue&type=style&index=0&id=36f569d9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f569d9",
  null
  
)

export default component.exports